{
  "auth": {
    "agree": "Согласен c",
    "createAccount": "Создать аккаунт",
    "createNewAccount": "Создать новый аккаунт",
    "email": "Email",
    "login": "Вход",
    "password": "Пароль",
    "recover_password": "Восстановить пароль",
    "sign_up": "Регистрация",
    "keep_logged_in": "Запомнить меня",
    "termsOfUse": "Условиями использования",
    "reset_password": "Сброс пароля"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Назад"
  },
  "dashboard": {
    "versions": "Версии",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "charts": {
      "trendyTrends": "Простой график",
      "showInMoreDetail": "Показать больше",
      "showInLessDetail": "Показать меньше",
      "loadingSpeed": "Скорость загрузки",
      "topContributors": "Список поставщиков",
      "showNextFive": "Показать следующие 5",
      "commits": "Коммиты"
    },
    "info": {
      "componentRichTheme": "component-rich theme",
      "completedPullRequests": "completed pull requests",
      "users": "users",
      "points": "points",
      "units": "units",
      "exploreGallery": "Explore gallery",
      "viewLibrary": "View Library",
      "commits": "commits",
      "components": "components",
      "teamMembers": "team members"
    },
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "forms": {
    "titles": {
      "form_1": "ФОРМА 1. СВЕДЕНИЯ ОБ ОТВЕСТВЕННОМ ЛИЦЕ СТРУКТУРНОГО ПОДРАЗДЕЛЕНИЯ/ ФИЛИАЛА ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИИ",
      "form_2": "ФОРМА 2.1. МОНИТОРИНГ, РЕАЛИЗУЕМЫХ ОБРАЗОВАТЕЛЬНЫХ ПРОГРАММ И КОНТИНГЕНТА ОБУЧАЮЩИХСЯ ОБРАЗОВАТЕЛЬНЫХ ОРГАНИЗАЦИЙ ТРАНСПОРТНОГО КОМПЛЕКСА",
      "form_22": "ФОРМА 2.2. МОНИТОРИНГ ПРОФЕССИОНАЛЬНО-ОБЩЕСТВЕННОЙ АККРЕДИТАЦИИ (ПОА) ПРОГРАММ СПО и ВО",
      "form_23": "ФОРМА 2.3. МОНИТОРИНГ ОБЪЕМОВ ДОПОЛНИТЕЛЬНОГО ПРИЕМА НА ПРОГРАММЫ ВО И СПО",
      "form_24": "ФОРМА 2.4.МОНИТОРИНГ ЗАЩИТ ДИССЕРТАЦИОННЫХ ИССЛЕДОВАНИЙ В ОТЧЕТНОМ ГОДУ",
      "form_3": "ФОРМА 3. МОНИТОРИНГ ПРОГРАММ ПРОФЕССИОНАЛЬНОГО ОБУЧЕНИЯ/ДОПОЛНИТЕЛЬНЫХ ПРОФЕССИОНАЛЬНЫХ ПРОГРАММ И КОНТИНГЕНТА ОБУЧАЮЩИХСЯ ОБРАЗОВАТЕЛЬНЫХ ОРГАНИЗАЦИЙ ТРАНСПОРТНОГО КОМПЛЕКСА",
      "form_4": "ФОРМА 4. МОНИТОРИНГ ТРУДОУСТРОЙСТВА ВЫПУСКНИКОВ ",
      "form_5": "ФОРМА 5. СВЕДЕНИЯ ОБ ОБНОВЛЕНИИ МАТЕРИАЛЬНОЙ БАЗЫ ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИИ В ТЕКУЩЕМ ГОДУ",
      "form_6": "ФОРМА 6. МОНИТОРИНГ РАЗВИТИЯ ИНФРАСТРУКТУРЫ ОБРАЗОВАТЕЛЬНЫХ ОРГАНИЗАЦИЙ ТРАНСПОРТНОГО КОМПЛЕКСА ЗА 2026 КАЛЕНДАРНЫЙ ГОД",
      "form_71": "ФОРМА 7.1. МОНИТОРИНГ НАЛИЧИЯ ОБЪЕКТОВ ИНФРАСТРУКТУРЫ",
      "form_72": "ФОРМА 7.2. МОНИТОРИНГ ОБЪЕКТОВ ОСНОВНЫХ  ФОНДОВ ОБРАЗОВАТЕЛЬНЫХ ОРГАНИЗАЦИЙ ТРАНСПОРТНОГО КОМПЛЕКСА. ЗДАНИЯ И СООРУЖЕНИЯ: ОБЪЕКТЫ ОБРАЗОВАНИЯ, ЗДРАВООХРАНЕНИЯ, КУЛЬТУРЫ, СПОРТА, ОБЩЕСТВЕННОГО ПИТАНИЯ, ОБЩЕЖИТИЯ, БИБЛИОТЕКИ И ДР.",
      "form_73": "ФОРМА 7.3. МОНИТОРИНГ ИНФРАСТРУКТУРЫ МЕДИЦИНСКИХ ПОДРАЗДЕЛЕНИЙ ОБРАЗОВАТЕЛЬНЫХ ОРГАНИЗАЦИЙ ТРАНСПОРТНОГО КОМПЛЕКСА",
      "form_74": "ФОРМА 7.4. МОНИТОРИНГ МЕДИЦИНСКИХ ОСМОТРОВ ЗА 2025 ГОД",
      "form_75": "ФОРМА 7.5. МОНИТОРИНГ ОКАЗАНИЯ ПСИХОЛОГИЧЕСКОЙ ПОМОЩИ В ОТЧЕТНОМ ГОДУ",
      "form_81": "ФОРМА 8.1. МОНИТОРИНГ ОБЪЕМОВ ФИНАНСИРОВАНИЯ НА РЕАЛИЗАЦИЮ ОБРАЗОВАТЕЛЬНЫХ ПРОГРАММ",
      "form_82": "ФОРМА 8.2. МОНИТОРИНГ ФИНАНСОВОГО ОБЕСПЕЧЕНИЯ ВЫПОЛНЕНИЯ ГОСУДАРСТВЕННОГО ЗАДАНИЯ",
      "form_83": "ФОРМА 8.3. МОНИТОРИНГ УЧАСТИЯ ОБУЧАЮЩИХСЯ СПО В ДЕМОНСТРАЦИОННОМ ЭКЗАМЕНЕ В ПРОМЕЖУТОЧНОЙ И ИТОГОВОЙ АТТЕСТАЦИИ",
      "form_9": "ФОРМА 9. МОНИТОРИНГ ЧИСЛЕННОСТИ РАБОТНИКОВ ОРГАНИЗАЦИИ",
      "form_1011": "ФОРМА 10.1.1 МОНИТОРИНГ ПРОВОДИМЫХ НАУЧНЫХ ИССЛЕДОВАНИЙ ПО КАТЕГОРИЯМ ЗА ОТЧЕТНЫЙ КАЛЕНДАРНЫЙ ГОД",
      "form_1012": "ФОРМА 10.1.2 МОНИТОРИНГ ОБЪЕМОВ РАСХОДОВ И ДОХОДОВ ПО НАУЧНЫМ ИССЛЕДОВАНИЯМ",
      "form_102": "ФОРМА 10.2. МОНИТОРИНГ ТЕМАТИКИ РЕАЛИЗУЕМЫХ НАПРАВЛЕНИЙ НАУЧНО-ИССЛЕДОВАТЕЛЬСКОЙ ДЕЯТЕЛЬНОСТИ",
      "form_1031": "ФОРМА 10.3.1. МОНИТОРИНГ ПУБЛИКАЦИОННОЙ АКТИВНОСТИ ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИИ ЗА ОТЧЕТНЫЙ КАЛЕНДАРНЫЙ ГОД НА 1 ИЮЛЯ ТЕКУШЕГО ГОДА",
      "form_1032": "ФОРМА 10.3.2. МОНИТОРИНГ ГРАНТОВОЙ ПОДДЕРЖКИ ОБРАЗОВАТЕЛЬНЫХ ОРГАНИЗАЦИЙ ТРАНСПОРТНЫХ КОРПОРАЦИЙ",
      "form_104": "ФОРМА 10.4. МОНИТОРИНГ РЕЗУЛЬТАТОВ НАУЧНОЙ, НАУЧНО-ТЕХНИЧЕСКОЙ ДЕЯТЕЛЬНОСТИ (ОХРАНОСПОСОБНЫЕ И/ИЛИ ОРИЕНТИРОВАННЫЕ НА ПРОМЫШЛЕННОЕ ИСПОЛЬЗОВАНИЕ)",
      "form_105": "ФОРМА 10.5. МОНИТОРИНГ ДИССЕРТАЦИОННЫХ СОВЕТОВ",
      "form_106": "ФОРМА 10.6. МОНИТОРИНГ НАУЧНЫХ ЖУРНАЛОВ (ИМЕЮЩИХ СТАТУС ПЕРИОДИЧЕСКОГО ИЗДАНИЯ)",
      "form_107": "ФОРМА 10.7. МОНИТОРИНГ УЧАСТИЯ В ЭКСПЕРТНЫХ СОВЕТАХ",
      "form_108": "ФОРМА 10.8. МОНИТОРИНГ СТРУКТУРЫ ЗАТРАТ НА НАУЧНЫЕ ИССЛЕДОВАНИЯ И РАЗРАБОТКИ (в тыс. руб.)",
      "form_111": "ФОРМА 11.1. МОНИТОРИНГ КОНТИНГЕНТА ОБУЧАЮЩИХСЯ ПО ПРОГРАММАМ В РАМКАХ ФП «ПРОФЕССИОНАЛИТЕТ»",
      "form_112": "ФОРМА 11.2. МОНИТОРИНГ РЕЗУЛЬТАТОВ РЕАЛИЗАЦИИ ФП «ПРОФЕССИОНАЛИТЕТ»",
      "form_121": "ФОРМА 12.1. ИНФОРМАЦИЯ ОБ ОБРАЗОВАТЕЛЬНЫХ ПРОГРАММАХ ВЫСШЕГО ОБРАЗОВАНИЯ И СРЕДНЕГО ПРОФЕССИОНАЛЬНОГО ОБРАЗОВАНИЯ, РЕАЛИЗУЕМЫХ В СЕТЕВОЙ ФОРМЕ С ЗАРУБЕЖНЫМИ ПАРТНЕРАМИ",
      "form_122": "ФОРМА 12.2. ИНФОРМАЦИЯ О ЧИСЛЕННОСТИ ИНОСТРАННЫХ ГРАЖДАН, ОБУЧАЮЩИХСЯ ПО ОСНОВНЫМ ПРОФЕССИОНАЛЬНЫМ И ДОПОЛНИТЕЛЬНЫМ ОБРАЗОВАТЕЛЬНЫМ ПРОГРАММАМ ПО ПРЕПОДАВАНИЮ И (ИЛИ) ИЗУЧЕНИЮ РУССКОГО ЯЗЫКА КАК ИНОСТРАННОГО, ПО СТРАНЕ ГРАЖДАНСТВА ПО СОСТОЯНИЮ НА 30.06. ТЕКУЩЕГО ГОДА",
      "form_123": "ФОРМА 12.3. ИНФОРМАЦИЯ О ДЕЙСТВУЮЩИХ СОГЛАШЕНИЯХ (ДОГОВОРАХ) С ИНОСТРАННЫМИ ОРГАНИЗАЦИЯМИ И (ИЛИ) МЕЖДУНАРОДНЫМИ ОБЪЕДИНЕНИЯМИ (ВКЛЮЧАЯ ИНФОРМАЦИЮ О ПРЕДМЕТЕ ДОГОВОРА И РЕАЛИЗУЕМЫХ ПРОЕКТАХ)",
      "form_124": "ФОРМА 12.4. ИНФОРМАЦИЯ ОБ УЧАСТИИ ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИИ В МЕЖДУНАРОДНЫХ ОБЪЕДИНЕНИЯХ (АССОЦИАЦИЯХ, СЕТЕВЫХ УНИВЕРСИТЕТАХ, КОНСОРЦИУМАХ И ДР.) В ОТЧЕТНОМ ГОДУ",
      "form_125": "ФОРМА 12.5. ИНФОРМАЦИЯ О КОЛИЧЕСТВЕ ПРИВЛЕЧЕННЫХ ИНОСТРАННЫХ ОБУЧАЮЩИХСЯ ПО СТРАНЕ ГРАЖДАНСТВА ЗА ОТЧЕТНЫЙ ГОД (КАЛЕНДАРНЫЙ ГОД)",
      "form_126": "ФОРМА 12.6. ИНФОРМАЦИЯ О КОЛИЧЕСТВЕ ИНОСТРАННЫХ ГРАЖДАН И ЛИЦ БЕЗ ГРАЖДАНСТВА ПО СТРАНЕ ГРАЖДАНСТВА ПРИВЛЕЧЕННЫХ В ЛЕТНИЕ/ЗИМНИЕ ШКОЛЫ ЗА ОТЧЕТНЫЙ ГОД",
      "form_127": "ФОРМА 12.7. СВЕДЕНИЯ О ЧИСЛЕННОСТИ ОБУЧАЮЩИХСЯ ОТЧИТЫВАЮЩЕЙСЯ ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИИ, ПРИНЯВШИХ УЧАСТИЕ В РАМКАХ МЕЖДУНАРОДНОЙ МОБИЛЬНОСТИ, ПО СТРАНАМ ПОСЕЩЕНИЯ ЗА ОТЧЕТНЫЙ ГОД",
      "form_128": "ФОРМА 12.8. СВЕДЕНИЯ О ЧИСЛЕННОСТИ ОБУЧАЮЩИХСЯ ИЗ ЧИСЛА ИНОСТРАННЫХ ГРАЖДАН И ЛИЦ БЕЗ ГРАЖДАНСТВА (ПО ФОРМАМ ОБУЧЕНИЯ), ПО ПРОГРАММАМ ВО И СПО»",
      "form_129": "ФОРМА 12.9. ИНФОРМАЦИЯ О ПРОЕКТАХ В НАУЧНОЙ СФЕРЕ, РЕАЛИЗОВАННЫХ/РЕАЛИЗУЕМЫХ В ОТЧЕТНОМ ГОДУ В ПАРТНЕРСТВЕ С ИНОСТРАННЫМИ ОРГАНИЗАЦИЯМИ И (ИЛИ) МЕЖДУНАРОДНЫМИ ОБЪЕДИНЕНИЯМИ",
      "form_1210": "ФОРМА 12.10. СВЕДЕНИЯ О ЧИСЛЕННОСТИ РАБОТНИКОВ ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИИ, ПРИНЯВШИХ УЧАСТИЕ В РАМКАХ МЕЖДУНАРОДНОЙ МОБИЛЬНОСТИ, ПО СТРАНАМ ПОСЕЩЕНИЯ ЗА ОТЧЕТНЫЙ ГОД",
      "form_1211": "ФОРМА 12.11. ИНФОРМАЦИЯ ОБ УЧАСТИИ ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИИ В МЕРОПРИЯТИЯХ МЕЖДУНАРОДНОГО УРОВНЯ ЗА ОТЧЕТНЫЙ ГОД",
      "form_1212": "ФОРМА 12.12. НЕПЕРСОНИФИЦИРОВАННЫЕ СВЕДЕНИЯ ОБ ИНОСТРАННЫХ РАБОТНИКАХ ИЗ ЧИСЛА НАУЧНО-ПЕДАГОГИЧЕСКИХ РАБОТНИКОВ И АДМИНИСТРАТИВНО-УПРАВЛЕНЧЕСКОГО ПЕРСОНАЛА ЗА ОТЧЕТНЫЙ ГОД",
      "form_131": "ФОРМА 13.1. МОНИТОРИНГ ИНФРАСТРУКТУРЫ ДЛЯ РЕАЛИЗАЦИИ МОЛОДЕЖНОЙ ПОЛИТИКИ",
      "form_132": "ФОРМА 13.2. МОНИТОРИНГ ОБЩЕЙ ИНФОРМАЦИИ ПО ОСНОВНЫМ НАПРАВЛЕНИЯМ СОЦИАЛЬНОЙ ПОДДЕРЖКИ МОЛОДЕЖИ",
      "form_133": "ФОРМА 13.3. МОНИТОРИНГ УЧАСТИЯ СТУДЕНТОВ В МОЛОДЕЖНОЙ ПОЛИТИКЕ УНИВЕРСИТЕТА ЗА ТЕКУЩИЙ УЧЕБНЫЙ ГОД",
      "form_134": "ФОРМА 13.4. МОНИТОРИНГ КОЛИЧЕСТВА МАССОВЫХ МЕРОПРИЯТИЙ ТЕКУЩЕГО УЧЕБНОГО ГОДА",
      "form_135": "ФОРМА 13.5. МОНИТОРИНГ КОЛИЧЕСТВА УЧАСТНИКОВ ВНЕУЧЕБНОЙ ДЕЯТЕЛЬНОСТИ ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИИ ВО",
      "form_141": "ФОРМА 14.1. МОНИТОРИНГ ВНЕДРЕНИЯ ПРОЕКТНОЙ ДЕЯТЕЛЬНОСТИ В ВЫСШЕМ ОБРАЗОВАНИИ",
      "form_142": "ФОРМА 14.2. МОНИТОРИНГ ПРОЕКТНОЙ ДЕЯТЕЛЬНОСТИ ПО ПРОГРАММАМ ВО",
      "form_151": "ФОРМА 15.1. МОНИТОРИНГ ПОКАЗАТЕЛЕЙ УЧАСТНИКОВ ГОСУДАРСТВЕННОЙ ПРОГРАММЫ «ПРИОРИТЕТ 2030»",
      "form_152": "ФОРМА 15.2. ПОКАЗАТЕЛИ ПО НАУЧНОЙ ИССЛЕДОВАТЕЛЬСКОЙ ДЕЯТЕЛЬНОСТИ ЗА 2025",
      "form_153": "ФОРМА 15.3. ИНДЕКС ТЕХНОЛОГИЧЕСКОГО ЛИДЕРСТВА УЧАСТНИКА ПРОГРАММЫ ПРИОРИТЕТ 2030",
      "form_154": "ФОРМА 15.4. МОНИТОРИНГ НОМЕНКЛАТУРЫ ТЕХНОЛОГИЧЕСКИХ КОМПАНИИ, В ТОМ ЧИСЛЕ МИПОВ ДОЛЯ ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИИ В УСТАВНОМ КАПИТАЛЕ КОТОРЫХ СОСТАВЛЯЕТ НЕ МЕНЕЕ 10%",
      "form_161": "ФОРМА 16.1. ХАРАКТЕРИСТИКИ МЕРОПРИЯТИЙ(РЕЗУЛЬТАТОВ) ПРЕДОСТАВЛЕНИЯ СУБСИДИЙ «ПЕРЕДОВЫЕ ИНЖЕНЕРНЫЕ ШКОЛЫ»",
      "form_162": "ФОРМА 16.2. ФИНАНСОВОЕ ОБЕСПЕЧЕНИЕ ПРОГРАММ РАЗВИТИЯ ПЕРЕДОВОЙ ИНЖЕНЕРНОЙ ШКОЛЫ",
      "form_171": "ФОРМА 17.1. МОНИТОРИНГ СВЕДЕНИЙ О НАУЧНЫХ ШКОЛАХ",
      "form_172": "ФОРМА 17.2. МОНИТОРИНГ ДЕЯТЕЛЬНОСТИ НАУЧНОЙ ШКОЛЫ",
      "checking": "Итоги",
      "result": "Завершение сбора данных",
      "users": "Пользователи",
      "monmanagement": "Мониторинг",
      "statistics": "Статус выполнения",
      "files": "Выгрузки файлов"
    },
    "footers": {
      "form_1": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_2": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_22": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_23": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_24": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_3": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_4": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_5": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_6": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_71": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_72": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_73": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_74": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_75": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_81": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_82": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_83": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_9": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_1011": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_1012": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_102": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_1031": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_1032": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_104": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_105": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_106": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_107": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_108": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_111": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_112": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_121": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_122": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_123": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_124": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_125": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_126": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_127": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_128": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_129": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_1210": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_1211": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_1212": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_1213": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_1214": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_131": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_132": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_133": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_134": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_135": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_141": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_142": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_151": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_152": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_153": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_154": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_161": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_162": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_171": "Руководитель стр. подразделения (филиала) образовательной организации ",
      "form_172": "Руководитель стр. подразделения (филиала) образовательной организации "
    },
    "buttons": {
      "delete": "Удалить",
      "edit": "Редактировать",
      "print": "Печать",
      "downloadcsv": "Скачать csv",
      "downloadxlsx": "Скачать xlsx",
      "renew": "Обновить данные"
    },
    "selects": {
      "country": "Выбор страны",
      "region": "Субъект РФ",
      "headOffice": "Головная организация",
      "structOffice": "Структурное подразделение",
      "countryMulti": "Country Multi Select",
      "multi": "Multi Select",
      "simple": "Simple Select",
      "searchable": "Select with search",
      "searchableMulti": "Multi Select with search",
      "nauch": "ФИО ответственного за научно-исследовательскую деятельность",
      "nauchtel": "Телефон ответственного",
      "title": "Selects"
    }
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "auth": "Аутентификация",
    "rating": "Rating",
    "buttons": "Кнопки",
    "charts": "Графики",
    "colorPickers": "Color Pickers",
    "collapses": "Collapses",
    "timelines": "Timelines",
    "dashboard": "Аналитика",
    "formElements": "Form Elements",
    "forms": "Формы",
    "mediumEditor": "Medium Editor",
    "grid": "Grid",
    "icons": "Icons",
    "cards": "Cards",
    "spinners": "Spinners",
    "login": "Имя пользователя",
    "maps": "Maps",
    "pages": "Сбор данных",
    "modals": "Modals",
    "notifications": "Notifications",
    "progressBars": "Progress Bars",
    "signUp": "Sign up",
    "lists": "Lists",
    "tables": "Tables",
    "markupTables": "Markup Tables",
    "dataTables": "Data Tables",
    "chips": "Chips",
    "tabs": "Tabs",
    "typography": "Typography",
    "uiElements": "UI Elements",
    "treeView": "Tree view",
    "dateTimePickers": "Date time pickers",
    "fileUpload": "File Upload",
    "colors": "Colors",
    "spacing": "Spacing",
    "sliders": "Sliders",
    "popovers": "Popovers",
    "chat": "Chat",
    "maplibre-maps": "MapLibre Maps",
    "yandex-maps": "Yandex Maps",
    "leaflet-maps": "Leaflet Maps",
    "bubble-maps": "Bubble Maps",
    "line-maps": "Line Maps",
    "login-singup": "Вход",
    "404-pages": "404 Pages",
    "faq": "Инструкции",
    "files": "Выгрузки",
    "profile": "Профиль",
    "form_1": "Форма №1",
    "form_2": "Форма №2.1",
    "form_22": "Форма №2.2",
    "form_23": "Форма №2.3",
    "form_24": "Форма №2.4",
    "form_3": "Форма №3",
    "form_4": "Форма №4",
    "form_5": "Форма №5",
    "form_6": "Форма №6",
    "form_71": "Форма №7.1",
    "form_72": "Форма №7.2",
    "form_73": "Форма №7.3",
    "form_74": "Форма №7.4",
    "form_75": "Форма №7.5",
    "form_81": "Форма №8.1",
    "form_82": "Форма №8.2",
    "form_83": "Форма №8.3",
    "form_9": "Форма №9",
    "form_1011": "Форма №10.1.1",
    "form_1012": "Форма №10.1.2",
    "form_102": "Форма №10.2",
    "form_1031": "Форма №10.3.1",
    "form_1032": "Форма №10.3.2",
    "form_104": "Форма №10.4",
    "form_105": "Форма №10.5",
    "form_106": "Форма №10.6",
    "form_107": "Форма №10.7",
    "form_108": "Форма №10.8",
    "form_111": "Форма №11.1",
    "form_112": "Форма №11.2",
    "form_121": "Форма №12.1",
    "form_122": "Форма №12.2",
    "form_123": "Форма №12.3",
    "form_124": "Форма №12.4",
    "form_125": "Форма №12.5",
    "form_126": "Форма №12.6",
    "form_127": "Форма №12.7",
    "form_128": "Форма №12.8",
    "form_129": "Форма №12.9",
    "form_1210": "Форма №12.10",
    "form_1211": "Форма №12.11",
    "form_1212": "Форма №12.12",
    "form_1213": "Форма №12.13",
    "form_1214": "Форма №12.14",
    "form_131": "Форма №13.1",
    "form_132": "Форма №13.2",
    "form_133": "Форма №13.3",
    "form_134": "Форма №13.4",
    "form_135": "Форма №13.5",
    "form_141": "Форма №14.1",
    "form_142": "Форма №14.2",
    "form_151": "Форма №15.1",
    "form_152": "Форма №15.2",
    "form_153": "Форма №15.3",
    "form_154": "Форма №15.4",
    "form_161": "Форма №16.1",
    "form_162": "Форма №16.2",
    "form_171": "Форма №17.1",
    "form_172": "Форма №17.2",
    "users": "Пользователи",
    "checking": "Итоги",
    "result": "Итог",
    "statistics": "Статус",
    "monmanagement": "Мониторинг"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "tables": {
    "basic": "Basic Table",
    "stripedHoverable": "Striped, Hoverable",
    "labelsActions": "Labels, Actions as Buttons",
    "sortingPaginationActionsAsIcons": "Sorting, Pagination, Actions as Icons",
    "star": "Star",
    "unstar": "Unstar",
    "edit": "Править",
    "delete": "Удалить",
    "searchByName": "Search by name",
    "searchTrendsBadges": "Search, Trends, Badges",
    "perPage": "Per Page",
    "report": "Report",
    "infiniteScroll": "Infinite Scroll",
    "selectable": "Selectable",
    "selected": "Selected",
    "serverSidePagination": "Server-Side Pagination",
    "emptyTable": "Пустая таблица",
    "noDataAvailable": "No Data Available.",
    "noReport": "There is no data to display. Report will be available on November 3, 2018.",
    "loading": "Загрузка",
    "headings": {
      "email": "Email",
      "name": "Имя",
      "firstName": "Имя",
      "lastName": "Фамилия",
      "status": "Статус",
      "country": "Страна",
      "location": "Место нахождения"
    }
  },
  "user": {
    "language": "Сменить язык",
    "logout": "Выход",
    "profile": "Профиль"
  }
}
